import _ from 'lodash'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import i18n from 'scoreboard/components/i18n'

var SendTo = BootslideMenu.extend({
	className: 'send-to',
	initialize: function (opt) {
		BootslideMenu.prototype.initialize.apply(this, arguments)
		this.canvas = opt && opt.canvas
		this.heading = opt.heading
		this.section = opt.section
		this.sendToOptions = opt.sendToOptions || []
		this.allowDynamicWidth = true
	},

	menu: function () {
		var options = []
		for (var i = 0; i < this.sendToOptions.length; i++) {
			var optionConstructorFn = this.sendToOptions[i]
			options.push({
				label: i18n.get('dashboards.dashboard'),
				// #26898 bootslide-menu will pass the model back to contentView,
				// so we can pull out the heading for the briefing slide labels
				model: { heading: this.heading },
				contentView: optionConstructorFn
			})
		}

		return {
			label: i18n.get('common.sendto'),
			target: options,
			width: this.width
		}
	}
})

export default SendTo

SendTo.__filename__ = 'components/send-to.js'
